var map = {
	"./Frame1.png": 5799,
	"./Frame2.png": 5164,
	"./HumanFrame.png": 6989,
	"./PetFrame.png": 8285,
	"./banner-img.png": 8011,
	"./banner-mobile.png": 6738,
	"./features-one.svg": 5833,
	"./features-three.svg": 4941,
	"./features-two.svg": 9999,
	"./gift-align-frame.png": 1969,
	"./gift-frame.png": 3389,
	"./how-it-works.png": 9814,
	"./how-work-bg.png": 935,
	"./how-works-one.svg": 9841,
	"./how-works-three.svg": 1637,
	"./how-works-two.svg": 1703,
	"./howworks-mobile.png": 9016,
	"./living-tribute-four.svg": 7575,
	"./living-tribute-one.svg": 1157,
	"./living-tribute-three.svg": 3193,
	"./living-tribute-two.svg": 8235,
	"./logo-main.png": 9718,
	"./moments-pictures.png": 8178,
	"./newsletter-shape-img.png": 8348,
	"./newsletter-side-img.png": 349,
	"./or-img.svg": 6114,
	"./pet.png": 2256,
	"./profile-bg.png": 1738,
	"./review-quate.png": 4538,
	"./right-arrow.svg": 3311,
	"./sarahjohnson.png": 8481,
	"./star.svg": 8775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;